<template>
  <ErrorSnackbar v-model="showError" :error="errorMessage" />
</template>

<script>
  import ErrorSnackbar from '../common/ErrorSnackbar';
  import { formHelperMixin } from '../../mixins/form-helper-mixin';
  import { PROCESS_PAYMENT_MUTATION } from '../../constants/graphql/payments';

  export default {
    name: 'PaymentProviderReturn',
    components: {
      ErrorSnackbar,
    },
    mixins: [formHelperMixin],
    props: {
      paymentPlan: {
        required: true,
        type: String,
      },
    },
    data() {
      return {
        errorMessage: null,
      };
    },
    computed: {
      checkoutId() {
        return this.$route.query.id;
      },
      resourcePath() {
        return this.$route.query.resourcePath;
      },
    },
    created() {
      if (this.checkoutId) {
        this.processPayment();
      } else {
        this.$emit('no-payment-provider-data');
      }
    },
    methods: {
      processPayment() {
        const checkoutId = this.checkoutId;
        const resourcePath = this.resourcePath;

        this.$apollo
          .mutate({
            mutation: PROCESS_PAYMENT_MUTATION,
            variables: {
              transactionId: checkoutId,
              resourcePath: resourcePath,
            },
          })
          .then(response => {
            if (response.data.processPayment.successfulPayment) {
              this.$router.push({
                name: 'SuccessPaymentPage',
                params: {
                  transactionType: response.data.processPayment.transactionType,
                },
              });
              this.gtm_tracking(response.data.processPayment);
            } else {
              this.displayError();
              this.$emit('payment-error');
              this.errorMessage = response.data.processPayment.description;
            }
          })
          .catch(error => {
            this.displayError();
            this.$emit('payment-error');
            throw error;
          });
      },
      gtm_tracking(processPaymentResponse) {
        this.$gtm.trackEvent({
          event: 'successful-payment',
          category: 'Payment',
          action: processPaymentResponse.transactionType,
          label: { transactionId: processPaymentResponse.transactionId },
          value: processPaymentResponse.amount,
        });
      },
    },
  };
</script>
